export const SET_MESSAGE = "SET_MESSAGE"
export const SET_LANGUAGE = "SET_LANGUAGE"
export const SET_THEME = "SET_THEME"
export const SET_SERVER_UNAVAILABLE = "SET_SERVER_UNAVAILABLE"
export const SERVER_NOT_FOUND_ENTITY = "SERVER_NOT_FOUND_ENTITY"

export const SET_DEPARTMENTS_TREE = "SET_DEPARTMENTS_TREE";
export const LOAD_DEPARTMENTS_TREE = "LOAD_DEPARTMENTS_TREE";
export const SET_DEPARTMENT_NAME = "SET_DEPARTMENT_NAME";
export const SET_DEPARTMENT_EMPLOYEES = "SET_DEPARTMENT_EMPLOYEES";
export const LOAD_DEPARTMENT_EMPLOYEES = "LOAD_DEPARTMENT_EMPLOYEES";
export const LOAD_ACADEMIC_DEPARTMENTS = "LOAD_ACADEMIC_DEPARTMENTS";
export const SET_ACADEMIC_DEPARTMENTS = "SET_ACADEMIC_DEPARTMENTS";
export const LOAD_DEPARTMENT_ANNOUNCEMENTS = "LOAD_DEPARTMENT_ANNOUNCEMENTS";
export const SET_DEPARTMENT_ANNOUNCEMENTS = "SET_DEPARTMENT_ANNOUNCEMENTS";
export const LOAD_DEPARTMENT_SCHEDULE = "LOAD_DEPARTMENT_SCHEDULE";
export const SAVE_DEPARTMENT_SCHEDULE = "SAVE_DEPARTMENT_SCHEDULE";
export const LOAD_EMPLOYEE_DETAILS = "LOAD_EMPLOYEE_DETAILS";
export const SET_EMPLOYEE_DETAILS = "SET_EMPLOYEE_DETAILS";
export const LOAD_PROFILING_RATING = "LOAD_PROFILING_RATING";
export const SET_PROFILING_RATING = "SET_PROFILING_RATING";
export const LOAD_PROFILING_QUEUE_APPLICATIONS = "LOAD_PROFILING_QUEUE_APPLICATIONS";
export const SET_PROFILING_QUEUE_APPLICATIONS = "SET_PROFILING_QUEUE_APPLICATIONS";
export const LOAD_PROFILING_SPECIALITIES = "LOAD_PROFILING_SPECIALITIES";
export const SET_PROFILING_SPECIALITIES = "SET_PROFILING_SPECIALITIES";
export const CREATE_PROFILING_APPLICATION_REQUEST = "CREATE_PROFILING_APPLICATION_REQUEST";
export const CREATE_PROFILING_APPLICATION_SUCCESS = "CREATE_PROFILING_APPLICATION_SUCCESS";
export const CREATE_PROFILING_APPLICATION_FAILURE = "CREATE_PROFILING_APPLICATION_FAILURE";
export const UPDATE_PROFILING_APPLICATION_REQUEST = "UPDATE_PROFILING_APPLICATION_REQUEST";
export const UPDATE_PROFILING_APPLICATION_REQUEST_SUCCESS = "UPDATE_PROFILING_APPLICATION_REQUEST_SUCCESS";
export const UPDATE_PROFILING_APPLICATION_REQUEST_FAILURE = "UPDATE_PROFILING_APPLICATION_REQUEST_FAILURE";
export const LOAD_PHONEBOOK_DATA = "LOAD_PHONEBOOK_DATA";
export const SET_PHONEBOOK_DATA = "SET_PHONEBOOK_DATA";
export const LOAD_FACULTIES = "LOAD_FACULTIES";
export const SET_FACULTIES = "SET_FACULTIES";
export const LOAD_SOCIAL_WORKS = "LOAD_SOCIAL_WORKS";
export const SET_SOCIAL_WORKS = "SET_SOCIAL_WORKS";
export const LOAD_RESEARCH_WORKS = "LOAD_RESEARCH_WORKS";
export const SET_RESEARCH_WORKS = "SET_RESEARCH_WORKS";
export const LOAD_IS_BRSM = "LOAD_IS_BRSM";
export const SET_IS_BRSM = "SET_IS_BRSM";
export const LOAD_IS_PROF_COM = "LOAD_IS_PROF_COM";
export const SET_IS_PROF_COM = "SET_IS_PROF_COM";
export const LOAD_SPECIALITIES_BY_FACULTY =
    "LOAD_SPECIALITIES_BY_FACULTY";
export const SET_SPECIALITIES_BY_FACULTY =
    "SET_SPECIALITIES_BY_FACULTY";
export const LOAD_COURSES_BY_FACULTY_AND_SPECIALITY =
    "LOAD_COURSES_BY_FACULTY_AND_SPECIALITY"
export const SET_COURSES_BY_FACULTY_AND_SPECIALITY =
    "SET_COURSES_BY_FACULTY_AND_SPECIALITY"
export const LOAD_SPECIALITIES_BY_FACULTY_AND_YEAR =
    "LOAD_SPECIALITIES_BY_FACULTY_AND_YEAR";
export const SET_SPECIALITIES_BY_FACULTY_AND_YEAR =
    "SET_SPECIALITIES_BY_FACULTY_AND_YEAR";
export const LOAD_DISCIPLINES = "LOAD_DISCIPLINES";
export const SET_DISCIPLINES = "SET_DISCIPLINES";
export const LOAD_RATING = "LOAD_RATING";
export const SET_RATING = "SET_RATING";
export const LOAD_RATING_DETAILS = "LOAD_RATING_DETAILS";
export const SET_RATING_DETAILS = "SET_RATING_DETAILS";
export const SET_CURRENT_WEEK = "SET_CURRENT_WEEK";
export const LOAD_CURRENT_WEEK = "LOAD_CURRENT_WEEK";
export const SET_EMPLOYEES = "SET_EMPLOYEES";
export const SET_EMPLOYEES_LIST = "SET_EMPLOYEES_LIST";
export const RESET_EMPLOYEES = "RESET_EMPLOYEES";
export const LOAD_EMPLOYEES = "LOAD_EMPLOYEES";
export const LOAD_EMPLOYEE = "LOAD_EMPLOYEE";
export const SET_EMPLOYEE = "SET_EMPLOYEE";
export const SET_EMPLOYEE_SCHEDULE = "SET_EMPLOYEE_SCHEDULE";
export const LOAD_EMPLOYEE_SCHEDULE = "LOAD_EMPLOYEE_SCHEDULE";
export const SET_EMPLOYEE_ANNOUNCEMENTS = "SET_EMPLOYEE_ANNOUNCEMENTS";
export const LOAD_EMPLOYEE_ANNOUNCEMENTS = "LOAD_EMPLOYEE_ANNOUNCEMENTS";
export const WAIT_SCHEDULE_DOWNLOAD = "WAIT_SCHEDULE_DOWNLOAD";
export const SET_SCHEDULE_DOWNLOAD = "SET_SCHEDULE_DOWNLOAD";
export const SET_GROUP_SCHEDULE = "SET_GROUP_SCHEDULE";
export const LOAD_GROUP_SCHEDULE = "LOAD_GROUP_SCHEDULE";
export const SET_GROUP_ANNOUNCEMENTS = "SET_GROUP_ANNOUNCEMENTS";
export const LOAD_GROUP_ANNOUNCEMENTS = "LOAD_GROUP_ANNOUNCEMENTS";
export const SET_WEEK_FILTERS = "SET_WEEK_FILTERS"

export const SET_MARK_SHEET_REQUESTS = "SET_MARK_SHEET_REQUESTS";
export const LOAD_MARK_SHEET_REQUESTS = "LOAD_MARK_SHEET_REQUESTS";
export const SET_MARK_SHEET_TYPES = "SET_MARK_SHEET_TYPES";
export const LOAD_MARK_SHEET_TYPES = "LOAD_MARK_SHEET_TYPES";
export const SEND_MARK_SHEET_REQUEST = "SEND_MARK_SHEET_REQUEST";
export const UPDATE_MARK_SHEET_REQUEST = "UPDATE_MARK_SHEET_REQUEST";
export const RECEIVE_SEND_MARK_SHEET_REQUEST_RESULT =
    "RECEIVE_SEND_MARK_SHEET_REQUEST_RESULT";
export const SET_MARK_SHEET_SUBJECTS = "SET_MARK_SHEET_SUBJECTS";
export const LOAD_MARK_SHEET_SUBJECTS = "LOAD_MARK_SHEET_SUBJECTS";
export const SET_MARK_SHEET_SUBJECT_EMPLOYEES =
    "SET_MARK_SHEET_SUBJECT_EMPLOYEES";
export const LOAD_MARK_SHEET_SUBJECT_EMPLOYEES =
    "LOAD_MARK_SHEET_SUBJECT_EMPLOYEES";
export const RESET_MARK_SHEET_SUBJECT_EMPLOYEES =
    "RESET_MARK_SHEET_SUBJECT_EMPLOYEES";

export const LOGIN_PROCESSING = "LOGIN_PROCESSING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const IS_ILLIQUID = "IS_ILLIQUID"
export const ARE_CONTACTS_VERIFIED = "ARE_CONTACTS_VERIFIED"
export const CLEAR_AUTH_ERROR = "CLEAR_AUTH_ERROR"

export const SET_MARKBOOK_DATA = "SET_MARKBOOK_DATA";
export const LOAD_MARKBOOK_DATA = "LOAD_MARKBOOK_DATA";

export const LOAD_IS_GROUP_HEAD = 'LOAD_IS_GROUP_HEAD';
export const SET_IS_GROUP_HEAD = 'SET_IS_GROUP_HEAD';
export const LOAD_WHO_CAN_NOTE = 'LOAD_WHO_CAN_NOTE';
export const SET_WHO_CAN_NOTE = 'SET_WHO_CAN_NOTE';
export const SEND_ASSIGN_RESPONSIBLE = 'SEND_ASSIGN_RESPONSIBLE';
export const RECEIVE_SEND_ASSIGN_RESPONSIBLE = 'RECEIVE_SEND_ASSIGN_RESPONSIBLE';
export const SEND_CREATE_OMISSION = 'SEND_CREATE_OMISSION';
export const RECEIVE_CREATE_OMISSION = 'RECEIVE_CREATE_OMISSION';

export const SET_PERSONAL_INFO = "SET_PERSONAL_INFO";
export const LOAD_PERSONAL_INFO = "LOAD_PERSONAL_INFO";

export const SET_PERSONAL_CV_DATA = "SET_PERSONAL_CV_DATA";
export const LOAD_PERSONAL_CV_DATA = "LOAD_PERSONAL_CV_DATA";

export const LOAD_PERSONAL_GROUP_INFO = "LOAD_PERSONAL_GROUP_INFO";
export const SET_PERSONAL_GROUP_INFO = "SET_PERSONAL_GROUP_INFO";

export const LOAD_PERSONAL_ANNOUNCEMENTS = "LOAD_PERSONAL_ANNOUNCEMENTS";
export const SET_PERSONAL_ANNOUNCEMENTS = "SET_PERSONAL_ANNOUNCEMENTS";

export const LOAD_CERTIFICATE_REQUESTS = "LOAD_CERTIFICATE_REQUESTS";
export const SET_CERTIFICATE_REQUESTS = "SET_CERTIFICATE_REQUESTS";
export const LOAD_CERTIFICATE_PLACES = "LOAD_CERTIFICATE_PLACES";
export const SET_CERTIFICATE_PLACES = "SET_CERTIFICATE_PLACES";
export const SEND_CERTIFICATE_REQUEST = "SEND_CERTIFICATE_REQUEST";
export const UPDATE_CERTIFICATE_REQUEST = "UPDATE_CERTIFICATE_REQUEST";
export const RECEIVE_SEND_CERTIFICATE_REQUEST_RESULT =
    "RECEIVE_SEND_CERTIFICATE_REQUEST_RESULT";

export const LOAD_LIBRARY_BOOKS = "LOAD_LIBRARY_BOOKS";
export const SET_LIBRARY_BOOKS = "SET_LIBRARY_BOOKS";
export const LOAD_LIBRARY_NEWS = "LOAD_LIBRARY_NEWS";
export const SET_LIBRARY_NEWS = "SET_LIBRARY_NEWS";

export const SET_DIPLOMA_INFO = 'SET_DIPLOMA_INFO';
export const LOAD_DIPLOMA_INFO = 'LOAD_DIPLOMA_INFO';
export const SET_DIPLOMA_AVAILABLE_TOPICS = 'SET_DIPLOMA_AVAILABLE_TOPICS';
export const LOAD_DIPLOMA_AVAILABLE_TOPICS = 'LOAD_DIPLOMA_AVAILABLE_TOPICS';
export const SEND_DIPLOMA_REQUEST = "SEND_DIPLOMA_REQUEST";
export const RECEIVE_DIPLOMA_REQUEST_RESULT_ON_SUCCESS = "RECEIVE_DIPLOMA_REQUEST_RESULT_ON_SUCCESS";
export const RECEIVE_DIPLOMA_REQUEST_RESULT_ON_ERROR = "RECEIVE_DIPLOMA_REQUEST_RESULT_ON_ERROR";
export const DELETE_DIPLOMA_REQUEST = "DELETE_DIPLOMA_REQUEST";
export const STOP_DELETING_DIPLOMA_REQUEST_ON_SUCCESS = "STOP_DELETING_DIPLOMA_REQUEST_ON_SUCCESS";
export const STOP_DELETING_DIPLOMA_REQUEST_ON_ERROR = "STOP_DELETING_DIPLOMA_REQUEST_ON_ERROR";

export const LOAD_PRACTICE_REQUESTS = "LOAD_PRACTICE_REQUESTS";
export const SET_PRACTICE_REQUESTS = "SET_PRACTICE_REQUESTS";
export const LOAD_PRACTICE_ENTERPRISES = "LOAD_PRACTICE_ENTERPRISES";
export const SET_PRACTICE_ENTERPRISES = "SET_PRACTICE_ENTERPRISES";
export const SEND_PRACTICE_REQUEST = "SEND_PRACTICE_REQUEST";
export const RECEIVE_PRACTICE_REQUEST_RESULT_ON_SUCCESS = "RECEIVE_PRACTICE_REQUEST_RESULT_ON_SUCCESS";
export const RECEIVE_PRACTICE_REQUEST_RESULT_ON_ERROR = "RECEIVE_PRACTICE_REQUEST_RESULT_ON_ERROR";
export const UPDATE_PRACTICE_REQUEST = "UPDATE_PRACTICE_REQUEST";
export const RECEIVE_UPDATED_PRACTICE_REQUEST_ON_SUCCESS = "RECEIVE_UPDATED_PRACTICE_REQUEST_ON_SUCCESS";
export const RECEIVE_UPDATED_PRACTICE_REQUEST_ON_ERROR = "RECEIVE_UPDATED_PRACTICE_REQUEST_ON_ERROR";

export const LOAD_PERSONAL_RATING_DATA = 'LOAD_PERSONAL_RATING_DATA';
export const SET_PERSONAL_RATING_DATA = 'SET_PERSONAL_RATING_DATA';

export const SET_PERSONAL_DATA = "SET_PERSONAL_DATA";
export const LOAD_PERSONAL_DATA = "LOAD_PERSONAL_DATA";
//DORMITORY
export const LOAD_DORMITORY_QUEUE_APPLICATION_REQUEST =
    "LOAD_DORMITORY_QUEUE_APPLICATION_REQUEST";
export const LOAD_DORMITORY_QUEUE_APPLICATION_SUCCESS =
    "LOAD_DORMITORY_QUEUE_APPLICATION_SUCCESS";
export const LOAD_DORMITORY_QUEUE_APPLICATION_FAILURE =
    "LOAD_DORMITORY_QUEUE_APPLICATION_FAILURE";
export const CREATE_DORMITORY_APPLICATION_REQUEST =
    "CREATE_DORMITORY_APPLICATION_REQUEST";
export const CREATE_DORMITORY_APPLICATION_SUCCESS =
    "CREATE_DORMITORY_APPLICATION_SUCCESS";
export const CREATE_DORMITORY_APPLICATION_FAILURE =
    "CREATE_DORMITORY_APPLICATION_FAILURE";
export const LOAD_PREMIUM_PENALTY_REQUEST = "LOAD_PREMIUM_PENALTY_REQUEST";
export const LOAD_PREMIUM_PENALTY_SUCCESS = "LOAD_PREMIUM_PENALTY_SUCCESS";
export const LOAD_PREMIUM_PENALTY_FAILURE = "LOAD_PREMIUM_PENALTY_FAILURE";
export const LOAD_PRIVILEGES_REQUEST = "LOAD_PRIVILEGES_REQUEST";
export const LOAD_PRIVILEGES_SUCCESS = "LOAD_PRIVILEGES_SUCCESS";
export const LOAD_PRIVILEGES_FAILURE = "LOAD_PRIVILEGES_FAILURE";

export const SET_STUDENTS = "SET_STUDENTS";
export const LOAD_STUDENTS = "LOAD_STUDENTS";
export const LOAD_AVAILABLE_FACULTIES = 'LOAD_AVAILABLE_FACULTIES'
export const SET_AVAILABLE_FACULTIES = 'SET_AVAILABLE_FACULTIES'
export const LOAD_STUDENT_GROUP_REPORT_DOWNLOAD = "LOAD_STUDENT_GROUP_REPORT_DOWNLOAD";
export const SAVE_STUDENT_GROUP_REPORT_DOWNLOAD = "SAVE_STUDENT_GROUP_REPORT_DOWNLOAD";

export const LOAD_LMS_APPLICATIONS = "LOAD_LMS_APPLICATIONS";
export const SET_LMS_APPLICATIONS = "SET_LMS_APPLICATIONS";
export const SIGN_LMS_CONTRACT = "SIGN_LMS_CONTRACT";
export const RECEIVE_SIGN_LMS_CONTRACT_RESULT_ON_SUCCESS = "RECEIVE_SIGN_LMS_CONTRACT_RESULT_ON_SUCCESS";
export const RECEIVE_SIGN_LMS_CONTRACT_RESULT_ON_ERROR = "RECEIVE_SIGN_LMS_CONTRACT_RESULT_ON_ERROR";
export const LOAD_LMS_CONTRACT = "LOAD_LMS_CONTRACT";
export const SAVE_LMS_CONTRACT = "SAVE_LMS_CONTRACT";
export const UPDATE_SKILLS = 'UPDATE_SKILLS';

export const SEND_UPDATE_SUMMARY_REQUEST = 'SEND_UPDATE_SUMMARY_REQUEST';
export const UPDATE_SUMMARY = 'UPDATE_SUMMARY';

export const SEND_UPDATE_JOB_SEARCH_REQUEST = 'SEND_UPDATE_JOB_SEARCH_REQUEST';
export const UPDATE_JOB_SEARCH = 'UPDATE_JOB_SEARCH';

export const SEND_UPDATE_SHOW_RATING_REQUEST = 'SEND_UPDATE_SHOW_RATING_REQUEST';
export const UPDATE_SHOW_RATING = 'UPDATE_SHOW_RATING';

export const SEND_UPDATE_PUBLISHED_REQUEST = 'SEND_UPDATE_PUBLISHED_REQUEST';
export const UPDATE_PUBLISHED = 'UPDATE_PUBLISHED';

export const SET_SKILLS = 'SET_SKILLS';
export const LOAD_SKILLS = 'LOAD_SKILLS';

export const UPDATE_PHOTO = 'UPDATE_PHOTO';
export const UPDATE_REFERENCES = 'UPDATE_REFERENCES'

export const CAN_ASSIGN_SUBGROUPS = 'CAN_ASSIGN_SUBGROUPS';
export const LOAD_SUBGROUPS = 'LOAD_SUBGROUPS';
export const SET_SUBGROUPS = 'SET_SUBGROUPS';
export const LOAD_SUBJECTS_FOR_SUBGROUPS = 'LOAD_SUBJECTS_FOR_SUBGROUPS';
export const SET_SUBJECTS_FOR_SUBGROUPS = 'SET_SUBJECTS_FOR_SUBGROUPS';
export const LOAD_ALL_SUBJECTS = 'LOAD_ALL_SUBJECTS';
export const SET_ALL_SUBJECTS = 'SET_ALL_SUBJECTS';
export const LOAD_LESSONS_BY_DATE = 'LOAD_LESSONS_BY_DATE';
export const SET_LESSONS_BY_DATE = 'SET_LESSONS_BY_DATE';
export const UPDATE_OMISSION = 'UPDATE_OMISSION';


export const SET_APPLICATION_DOWNLOAD = 'SET_APPLICATION_DOWNLOAD'
export const LOAD_APPLICATION_REPORT = 'LOAD_APPLICATION_REPORT'
export const SAVE_APPLICATION_REPORT = 'SAVE_APPLICATION_REPORT'

export const GET_GROUPS_BY_NAME_REQUEST = "GET_GROUPS_BY_NAME_REQUEST";
export const GET_GROUPS_BY_NAME_SUCCESS = "GET_GROUPS_BY_NAME_SUCCESS";
export const GET_GROUPS_BY_NAME_FAILURE = "GET_GROUPS_BY_NAME_FAILURE";

//omissions
export const LOAD_OMISSIONS_BY_STUDENT = "LOAD_OMISSIONS_BY_STUDENT";
export const SET_OMISSIONS_BY_STUDENT = "SET_OMISSIONS_BY_STUDENT";
export const LOAD_MONTH_STUDENT_OMISSION_COUNTS = "LOAD_MONTH_STUDENT_OMISSION_COUNTS";
export const SET_MONTH_STUDENT_OMISSION_COUNTS = "SET_MONTH_STUDENT_OMISSION_COUNTS";

export const CREATE_OMISSION_REQUEST = "CREATE_OMISSION_REQUEST";
export const CREATE_OMISSION_REQUEST_SUCCESS = "CREATE_OMISSION_REQUEST_SUCCESS";
export const CREATE_OMISSION_REQUEST_FAILURE = "CREATE_OMISSION_REQUEST_FAILURE";
export const LOAD_OMISSION_REQUEST = "LOAD_OMISSION_REQUEST";
export const LOAD_OMISSION_REQUEST_SUCCESS = "LOAD_OMISSION_REQUEST_SUCCESS";
export const LOAD_OMISSION_REQUEST_FAILURE = "LOAD_OMISSION_REQUEST_FAILURE";
export const LOAD_OMISSION_CERTIFICATE_TYPES_REQUEST = "LOAD_OMISSION_CERTIFICATE_TYPES_REQUEST";
export const LOAD_OMISSION_CERTIFICATE_TYPES_SUCCESS = "LOAD_OMISSION_CERTIFICATE_TYPES_SUCCESS";
export const LOAD_OMISSION_CERTIFICATE_TYPES_FAILURE = "LOAD_OMISSION_CERTIFICATE_TYPES_FAILURE";
export const LOAD_OMISSION_CERTIFICATE_TYPES = "LOAD_OMISSION_CERTIFICATE_TYPES";
export const SET_OMISSION_CERTIFICATE_TYPES = "SET_OMISSION_CERTIFICATE_TYPES";
export const UPDATE_OMISSION_REQUEST = "UPDATE_OMISSION_REQUEST";
export const UPDATE_OMISSION_REQUEST_SUCCESS = "UPDATE_OMISSION_REQUEST_SUCCESS";
export const UPDATE_OMISSION_REQUEST_FAILURE = "UPDATE_OMISSION_REQUEST_FAILURE";

//notifications
export const LOAD_NOTIFICATIONS = "LOAD_NOTIFICATIONS"
export const CONCAT_NOTIFICATIONS = "CONCAT_NOTIFICATIONS"
export const RESET_NOTIFICATIONS = "RESET_NOTIFICATIONS"
export const UPDATE_NOTIFICATIONS = "UPDATE_NOTIFICATIONS"
export const LOAD_NOT_VIEWED_NOTIFICATIONS_COUNT = "LOAD_NOT_VIEWED_NOTIFICATIONS_COUNT"
export const SET_NOT_VIEWED_NOTIFICATIONS_COUNT = "SET_NOT_VIEWED_NOTIFICATIONS_COUNT"
export const SET_FULL_SHOW_FOR_NOTIFICATION = "SET_FULL_SHOW_FOR_NOTIFICATION"